import { Flex, Grid, Heading } from "@daangn/carotene";
import type { PropsWithChildren } from "react";
import React from "react";

import * as css from "./SectionContainer.css";

type Props = {
  title: string;
  subTitle?: string | null;
  rightSection?: React.ReactNode;
};

const SectionContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  ...props
}) => {
  return (
    <div className={css.container}>
      <Flex className={css.header}>
        <Grid columns={1} gap={1.5}>
          <Heading level={2} size="medium">
            {props.title}
          </Heading>
          {props.subTitle && <p className={css.subTitle}>{props.subTitle}</p>}
        </Grid>
        {props.rightSection && (
          <Flex className={css.right}>{props.rightSection}</Flex>
        )}
      </Flex>
      {children}
    </div>
  );
};

export default SectionContainer;
